import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';

import styles from '../../../../styles/icons/logos/molson-mvp.module.scss';

import mvpLogoEn from '../../../../img/nhl/HR-MVP-2025-EN.png';
import mvpLogoFr from '../../../../img/nhl/HR-MVP-2025-FR.png';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

function NhlMolsonMvp({ className }) {
    const { locale } = useIntl();
    return (
        <div className={classNames([styles.container, { [className]: className !== null }])}>
            <img
                src={locale === 'fr' ? mvpLogoFr : mvpLogoEn}
                className={styles.mvp}
                alt="Molson MVP"
            />
        </div>
    );
}

NhlMolsonMvp.propTypes = propTypes;
NhlMolsonMvp.defaultProps = defaultProps;

export default NhlMolsonMvp;
